<template>
  <div class="app">
    <router-view></router-view>

    <footer>
      <a href="https://drfirst.com/backline-terms-of-use/" class="logo">
        <img src="./assets/dn-logo-tagline.png" class="logo-image" alt="Term Of Use">
      </a>
      <div class="legal">
        © 2023 Copyright
        <br />DrFirst, Inc.
        <br />All Rights Reserved
        <br />
        <a href="https://drfirst.com/backline-privacy-policy/">Privacy Policy</a>.
      </div>
    </footer>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  created() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
};
</script>

<style lang="scss">
footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  border-top: solid 1px rgba(0, 0, 0, 0.1);
  height: 100px;
  .logo {
    flex-shrink: 0;
    width: 130px;
    img {
      width: 80px;
      ;
    }
    margin-right: 20px;
    display: block;
  }
  .legal {
    font-size: 0.7rem;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1rem;
    @media (min-width: 1000px) {
      br {
        display: none;
      }
    }
  }
}
</style>
